export default {
  namespaced: true,
  router: {
    title: "Router | Routers",
    status: "status",
    description: "Descrição",
    latitude: "latitude",
    longitude: "longitude",
    velocity: "velocidad",
    direction: "direção",
    CAD_folio: "folio CAD",
    address: "endereço",
    active: "activo",
    notify_cad_c5_cdmx: "notifica CAD C5 CDMX",
    notify_cad_c5_jalisco: "notifica CAD C5 JALISCO",
    notify_cad_c5_edomex: "notifica CAD C5 EDOMEX",
    altitude: "altitud",
    imei: "IMEI",
    totem_key: "totem key",
    totem_id: "id totem",
    ip_vpn: "IP VPN",
    last_log: "último registro",
    has_router: "Tem roteador",
    force_network_mask: "Máscara de Rede de Força",
    information: "Informações do Roteador",
    add_new_router: "Adicionar novo roteador",
  }
}
